<template>
  <el-select
    style="width: 100%"
    v-model="selVal"
    clearable
    :placeholder="placeholder"
    @change="change"
  >
    <el-option
      v-for="item in dicItems"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    ></el-option>
  </el-select>
</template>

<script>
import { loadEnum } from "@/api/sys/dicType";
export default {
  model: {
    event: "change",
  },
  props: {
    value: String,
    column: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  watch: {
    value() {
      this.selVal = this.value;
    },
  },
  data() {
    return {
      selVal: this.value,
      dicItems: [],
    };
  },
  computed:{
    placeholder() {
      return this.column.placeholder || "请输入" + this.column.name;
    },
  },
  created() {
    if (this.column.dicData && this.column.dicData.length) {
      this.dicItems = this.column.dicData;
    } else {
      if (this.column.dicKey) {
        loadEnum(this.column.dicKey).then((res) => {
          this.dicItems = res.data.data;
        });
      }
    }
  },
  methods: {
    change() {
      if (this.column.change && typeof this.column.change == "function") {
        this.column.change(this.selVal, this.column);
      }
      this.$emit("change", this.selVal, this.column);
    },
  },
};
</script>

<style>
</style>